import { render, staticRenderFns } from "./TextValid.vue?vue&type=template&id=b01d84d6&scoped=true&"
import script from "./TextValid.vue?vue&type=script&lang=js&"
export * from "./TextValid.vue?vue&type=script&lang=js&"
import style0 from "./TextValid.vue?vue&type=style&index=0&id=b01d84d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d84d6",
  null
  
)

export default component.exports